// @flow
import OHLCV from './OHLCV';
import connect from './connect';

export default connect(OHLCV);



// WEBPACK FOOTER //
// ./src/components/OHLCV/index.js